import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import Select from "react-select";
import { debounce } from "lodash";
import ReactPaginate from 'react-paginate';
import XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';


// Add compact table styles
const compactTableStyles = `
    .compact-paid-table {
        font-size: 0.8rem;
    }
    
    .compact-paid-table thead th {
        font-size: 0.75rem;
        padding: 8px 6px;
        white-space: nowrap;
    }
    
    .compact-paid-table tbody td {
        font-size: 0.75rem;
        padding: 6px 5px;
        white-space: nowrap;
    }
    
    .compact-paid-table tbody td small {
        font-size: 0.7rem;
    }
    
    .compact-paid-table .btn-sm {
        font-size: 0.7rem;
        padding: 3px 6px;
    }
    
    .compact-paid-table a {
        font-size: 0.75rem;
    }
`;

export default function PaidList() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [date, setDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [devision, setDevision] = useState([]);
    const [subject, setSubjects] = useState([]);
    const [year, setYear] = useState([]);
    const [term, setTerm] = useState([]);
    const [fees, setFeesList] = useState([]);
    const [standard, setstandard] = useState([]);
    const [selclass, setselclass] = useState("");
    const [allStudent, setAllStudent] = useState([]);
    const [selectedStud, setSelectedStudent] = useState("");
    const [selectedClassStud, setselectedClassStud] = useState([]);
    const [selectedDevStud, setselectedDevStud] = useState("");
    const [selectedFeesStud, setselectedFeesStud] = useState("");
    const [amount, setAmount] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [stClass, setStClass] = useState([]);
    const [stDev, setstDev] = useState([]);
    const [stAdmin, setstAdmin] = useState([]);
    const [selectedDevStudType, setselectedDevStudType] = useState([]);
    const [selectedDAdmin, setselectedAdmin] = useState("");
    const [selectedFrom, setselectedFrom] = useState(moment().format("YYYY-MM-DD HH:mm:ss")); // Default to today's date
    const [selectedTo, setselectedTo] = useState(moment().format("YYYY-MM-DD HH:mm:ss")); // Default to today's date
    const [createdFrom, setCreatedFrom] = useState(""); // Created on date filter
    const [createdTo, setCreatedTo] = useState(""); // Created on date filter
    const [stYear, setstYear] = useState([]);
    const [selectedDevYear, setselectedDevYear] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stAgent, setstAgent] = useState([]);
    const [selectedDevStudAgentType, setselectedDevStudAgentType] = useState("");
    const [feesTypeHeads, setFeesTypeHeads] = useState([]);
    const [selectedHead, setSelectedHead] = useState([]);

    const [showReportModal, setShowReportModal] = useState(false);
    const [reportStep, setReportStep] = useState(1);
    const [selectedReportAdmin, setSelectedReportAdmin] = useState(null);
    const [sendingReport, setSendingReport] = useState(false);

    const [currentPage, setCurrentPage] = useState(0);
    const [totalTasks, setTotalTasks] = useState("");
    const [tasksPerPage] = useState(100);  // Assuming 10 tasks per page

    const handlePageClick = (event) => {
        const selectedPage = event.selected + 1; // ReactPaginate uses zero-based index
        if (selectedPage !== currentPage) {
            setCurrentPage(selectedPage);
            fetchTaskDetails(selectedFrom, selectedTo, selectedClassStud, selectedDevStud, selectedDevStudType, selectedDAdmin, selectedPage, selectedDevStudAgentType, createdFrom, createdTo, selectedHead);
        }
    };

    useEffect(() => {
        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setStClass(res.data.data);
        });

        http.get(`/devision`).then((res) => {
            setstDev(res.data.data);
        });

        http.get(`/admins?login_user=${user.id}`).then((res) => {
            setstAdmin(res.data.users);
        });

        http.get(`/year`).then((res) => {
            setstYear(res.data.data);
        });

        http.get(`/agent?company_id=${user.company_id}`).then((res) => {
            setstAgent(res.data.data);
        });

        http.get(`/fees_type_heads?login_user=${user.id}`).then((res) => {
            if (res.data.success) setFeesTypeHeads(res.data.data || []);
        });

        // Initial data load
        fetchTaskDetails(selectedFrom, selectedTo, selectedClassStud, selectedDevStud, selectedDevStudType, selectedDAdmin, 1, selectedDevStudAgentType, "", "", []);

        // Other API calls...
    }, []); // Remove the dependencies that were triggering automatic filtering

    const [exporting, setExporting] = useState(false);

    const buildListEndpoint = (page = 1, perPage = tasksPerPage) => {
        const classParam = Array.isArray(selectedClassStud) ? selectedClassStud.map(o => o.value).join(',') : selectedClassStud;
        const typeParam = Array.isArray(selectedDevStudType) ? selectedDevStudType.map(o => o.value).join(',') : selectedDevStudType;
        const headParam = Array.isArray(selectedHead) ? selectedHead.map(o => o.value).join(',') : selectedHead;
        return `/student_annual_fee_sub?date_from=${selectedFrom}&date_to=${selectedTo}&class=${classParam}&dev=${selectedDevStud}&type=${typeParam}&added=${selectedDAdmin}&page=${page}&per_page=${perPage}&company_id=${user.company_id}&agent=${selectedDevStudAgentType}&created_from=${createdFrom}&created_to=${createdTo}&head=${headParam}`;
    };

    const fetchTaskDetails = (fromDate, toDate, selClass, selDev, typePays, byAdmin, currentPage = 1, agent = "", createdFromDate = "", createdToDate = "", headFilter = []) => {
        setIsLoading(true);
        const classParam = Array.isArray(selClass) ? selClass.map(o => o.value).join(',') : selClass;
        const typeParam = Array.isArray(typePays) ? typePays.map(o => o.value).join(',') : typePays;
        const headParam = Array.isArray(headFilter) ? headFilter.map(o => o.value).join(',') : headFilter;
        let endpoint = `/student_annual_fee_sub?date_from=${fromDate}&date_to=${toDate}&class=${classParam}&dev=${selDev}&type=${typeParam}&added=${byAdmin}&page=${currentPage}&per_page=${tasksPerPage}&company_id=${user.company_id}&agent=${agent}&created_from=${createdFromDate}&created_to=${createdToDate}&head=${headParam}`;

        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data); // Set the tasks for the current page
                    setTotalTasks(res.data.total); // Set the total number of tasks
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };

    const fetchAllTasksForExport = async () => {
        const totalCount = parseInt(totalTasks, 10) || 0;
        if (totalCount === 0) return [];
        if (totalCount <= tasks.length && tasks.length < tasksPerPage) {
            return tasks;
        }
        const res = await http.get(buildListEndpoint(1, totalCount));
        return Array.isArray(res.data.data) ? res.data.data : [];
    };

    const calculateExportTotals = (exportTasks) => ({
        cashSum: exportTasks.reduce((total, task) => task.ext_1 === 'Cash' ? total + parseFloat(task.amount) : total, 0),
        upiSum: exportTasks.reduce((total, task) => task.ext_1 === 'UPI' ? total + parseFloat(task.amount) : total, 0),
        DbankSum: exportTasks.reduce((total, task) => task.ext_1 === 'Dbank' ? total + parseFloat(task.amount) : total, 0),
        AgentSum: exportTasks.reduce((total, task) => task.ext_1 === 'Agent' ? total + parseFloat(task.amount) : total, 0),
        totalSum: exportTasks.reduce((total, task) => total + parseFloat(task.amount), 0),
        totalNegativeSum: exportTasks.reduce((total, task) => {
            const amount = parseFloat(task.amount);
            return task.ext_1 === 'Concession' ? total + amount : total;
        }, 0),
    });


    const handleSelectChangeClass = (event) => {
        setselectedClassStud(event.target.value || []);
    };

    const handleSelectChangeDev = (event) => {
        setselectedDevStud(event.target.value);
    };

    const handleSelectChange = (selectedOption) => {
        setSelectedStudent(selectedOption);
    };

    const statusUpdate = (e) => {
        setCurrentStatus(e.target.value);
    };

    const initialState = {
        name: "",
    };

    const deleteTask = async (taskId) => {
        await http
            .delete(`/departments_del/${taskId}`)
            .then((response) => {
                toast.success("Departments Deleted successfully !");
                fetchTaskDetails();
            })
            .catch((err) => {
                console.error("Error deleting task", err);
            });
    };

    const options = allStudent.map((user) => ({
        value: user.id,
        label: `${user.adm_no} - ${user.ext_2}${user.ext_3} - ${user.class}${user.section}  - ${user.mobile}`,
    }));

    const handleClearFields = () => {
        window.location.reload();
    };

    const handleEmailSent = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            await http.get(`/student_annual_fee_sub_mail?company_id=${user.company_id}`);
            toast.success("Email sent successfully!");
            window.location.reload();
        } catch (err) {
            console.error("Error sending mail", err);
            toast.error("Failed to send email.");
        } finally {
            setLoading(false); // Reset loading state
        }
    }

    const handleEmailSentExport = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            const response = await http.get(`/student_annual_fee_sub_mail_export?company_id=${user.company_id}`, {
                responseType: 'blob', // Important to handle the file download
            });

            // Create a blob from the response data
            const blob = new Blob([response.data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);

            // Create a link element and trigger a download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'fees.csv'); // or any other filename you want
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            toast.success("Exported successfully!");
        } catch (err) {
            console.error("Error in export", err);
            toast.error("Failed to export.");
        } finally {
            setLoading(false); // Reset loading state
        }
    };

    //for filter export
    const handleEmailSentExportFilter = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            const classParam = Array.isArray(selectedClassStud) ? selectedClassStud.map(o => o.value).join(',') : selectedClassStud;
            const typeParam = Array.isArray(selectedDevStudType) ? selectedDevStudType.map(o => o.value).join(',') : selectedDevStudType;
            const headParam = Array.isArray(selectedHead) ? selectedHead.map(o => o.value).join(',') : selectedHead;
            const response = await http.get(`/student_annual_fee_sub_mail_export_filter?date_from=${selectedFrom}&date_to=${selectedTo}&class=${classParam}&dev=${selectedDevStud}&type=${typeParam}&added=${selectedDAdmin}&company_id=${user.company_id}&agent=${selectedDevStudAgentType}&created_from=${createdFrom}&created_to=${createdTo}&head=${headParam}`, {
                responseType: 'blob',
            });

            // Create a blob from the response data
            const blob = new Blob([response.data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);

            // Create a link element and trigger a download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'fees.csv'); // or any other filename you want
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            toast.success("Exported successfully!");
        } catch (err) {
            console.error("Error in export", err);
            toast.error("Failed to export.");
        } finally {
            setLoading(false); // Reset loading state
        }
    };


    const superAdmins = stAdmin.filter((admin) => admin.department_id === 1);

    const handleSendReport = async () => {
        if (!selectedReportAdmin) {
            toast.error("Please select an admin to send the report.");
            return;
        }
        setSendingReport(true);
        try {
            const classParam = Array.isArray(selectedClassStud) ? selectedClassStud.map(o => o.value).join(',') : selectedClassStud;
            const typeParam = Array.isArray(selectedDevStudType) ? selectedDevStudType.map(o => o.value).join(',') : selectedDevStudType;
            let endpoint = `/student_annual_fee_sub_mail_with_due?date_from=${selectedFrom}&date_to=${selectedTo}&class=${classParam}&dev=${selectedDevStud}&type=${typeParam}&added=${selectedDAdmin}&company_id=${user.company_id}&agent=${selectedDevStudAgentType}&created_from=${createdFrom}&created_to=${createdTo}&email=${selectedReportAdmin.email}`;
            await http.get(endpoint);
            toast.success(`Report sent successfully to ${selectedReportAdmin.name}!`);
            setShowReportModal(false);
            setSelectedReportAdmin(null);
        } catch (err) {
            console.error("Error sending report", err);
            toast.error("Failed to send report.");
        } finally {
            setSendingReport(false);
        }
    };

    const handleSubmit = async () => {
        if (tasks.length === 0 || !selectedFeesStud) {
            toast.error("Please select a student and fees type before submitting.");
            return true;
        }

        if (tasks.length === 0 || !selectedFeesStud || !amount || !dueDate) {
            toast.error("Please enter due date and amount");
            return;
        }


        try {
            const promises = [];

            for (let i = 0; i < tasks.length; i++) {
                const task = tasks[i];

                const formData = {
                    admn_no: task.adm_no,
                    ext_1: task.roll_no,
                    first_name: task.ext_2,
                    last_name: task.ext_3,
                    class: task.class,
                    dev: task.section,
                    fees_id: selectedFeesStud,
                    student_id: task.id,
                    amount: amount,
                    ext_5: dueDate,
                };

                // Push the promise for each API call to the array
                promises.push(http.post('/annual_fees', formData));
            }

            // Wait for all promises to be resolved
            await Promise.all(promises);

            // If all promises are resolved, show success toast
            toast.success("Fees data updated successfully");
            fetchTaskDetails(selectedStud, selectedClassStud, selectedDevStud, selectedFeesStud);

            // handleClearFields();
        } catch (error) {
            // Handle errors
            console.error("Error submitting tasks:", error);
            // toast.error("Error submitting tasks. Please try again.");
        }
    };
    function handleSelectChangeFees(event) {
        setselectedFeesStud(event.target.value);
    }

    function handleChangeAmount(event) {
        setAmount(event.target.value)
    }

    function handleChangeDate(event) {
        setselectedFrom(event.target.value)
    }

    function handleChangeDateEnd(event) {
        setselectedTo(event.target.value)
    }

    const handleMonthChange = (event) => {
        const month = event.target.value;
        if (!month) return;
        const year = moment().year();
        const start = moment(`${year}-${month}-01`).startOf("month").format("YYYY-MM-DD");
        const end = moment(`${year}-${month}-01`).endOf("month").format("YYYY-MM-DD");
        setselectedFrom(start);
        setselectedTo(end);
    };

    const calculateDue = (amount, ext_6) => {
        const due = amount - ext_6;
        return due < 0 ? "No due" : due;
    };
    const cashSum = tasks.reduce((total, task) => task.ext_1 === "Cash" ? total + parseFloat(task.amount) : total, 0);
    const upiSum = tasks.reduce((total, task) => task.ext_1 === "UPI" ? total + parseFloat(task.amount) : total, 0);
    const DbankSum = tasks.reduce((total, task) => task.ext_1 === "Dbank" ? total + parseFloat(task.amount) : total, 0);
    const AgentSum = tasks.reduce((total, task) => task.ext_1 === "Agent" ? total + parseFloat(task.amount) : total, 0);
    const totalSum = tasks.reduce((total, task) => total + parseFloat(task.amount), 0);
    //  const totalSumCon = tasks.reduce((total, task) => total + parseFloat(task.amount), 0);

    const totalNegativeSum = tasks.reduce((total, task) => {
        const amount = parseFloat(task.amount);
        return task.ext_1 === "Concession" ? total + amount : total;
    }, 0);

    const handleSelectChangeDevType = (event) => {
        setselectedDevStudType(event.target.value || []);
    };

    const handleSelectChangeAdmin = (event) => {
        setselectedAdmin(event.target.value);
    };

    const handleSelectChangeAgentType = (event) => {
        setselectedDevStudAgentType(event.target.value);
    };

    const formatLastName = (lastName) => {
        if (!lastName) {
            return ''; // or handle it as you see fit
        }
        return lastName.length > 13 ? lastName.substring(0, 13) + '...' : lastName;
    };
    //Real time year changing (multi-select)
    const handleSelectChangeYear = (selected) => {
        setselectedDevYear(selected || []);
        if (!selected || selected.length === 0) {
            setFeesList([]);
            return;
        }
        setLoading(true);
        const yearValues = selected.map(s => s.value);
        Promise.all(yearValues.map(yr => http.get(`/tution_feeslists?company_id=${user.company_id}&year=${yr}`)))
            .then((responses) => {
                const allFees = responses.flatMap(res => res.data.data || []);
                const uniqueFees = allFees.filter((fee, idx, arr) => arr.findIndex(f => f.id === fee.id) === idx);
                setFeesList(uniqueFees);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const handleFilter = () => {
        fetchTaskDetails(selectedFrom, selectedTo, selectedClassStud, selectedDevStud, selectedDevStudType, selectedDAdmin, 1, selectedDevStudAgentType, createdFrom, createdTo, selectedHead);
        setCurrentPage(0); // Reset to first page when filtering
    };

    const getStudentType = (task) => task.annual_data?.std_type || task.std_type || '';

    const handleExportExcel = async () => {
        if (tasks.length === 0) { toast.error('No data to export'); return; }
        setExporting(true);
        const loadingToast = toast.loading('Preparing Excel export...');
        try {
            const exportTasks = await fetchAllTasksForExport();
            if (exportTasks.length === 0) {
                toast.error('No data to export', { id: loadingToast });
                return;
            }
            const totals = calculateExportTotals(exportTasks);
            const data = exportTasks.map((task, idx) => ({
            'No': idx + 1,
            'Paid On': task.alt_date ? moment(task.alt_date).format('DD MMM, YY') : moment(task.created_at).format('DD MMM, YY'),
            'Adm No': task.adm_no || '',
            'Student Name': `${task.first_name || ''} ${task.last_name || ''}`.trim(),
            'Type': getStudentType(task),
            'Class': task.class || '',
            'Div': task.dev || '',
            'Fee Type': task.fees_name ? task.fees_name.name : 'N/A',
            'Head': task.fees_name?.fees_type_head?.name || '-',
            'Ref': task.ext_2 || '',
            'Concession': task.ext_1 === 'Concession' ? parseFloat(task.amount) : 0,
            'Cash': task.ext_1 === 'Cash' ? parseFloat(task.amount) : 0,
            'UPI': task.ext_1 === 'UPI' ? parseFloat(task.amount) : 0,
            'Dbank': task.ext_1 === 'Dbank' ? parseFloat(task.amount) : 0,
            'Mode Amt': task.ext_1 === 'Agent' ? parseFloat(task.amount) : 0,
            'Total': parseFloat(task.amount) || 0,
            'Added By': task.user_name ? task.user_name.name : '',
            'Mode': task.agent_data ? task.agent_data.name : '',
        }));

        data.push({
            'No': '', 'Paid On': '', 'Adm No': '', 'Student Name': '', 'Type': '', 'Class': '', 'Div': '',
            'Fee Type': 'TOTAL', 'Head': '', 'Ref': '',
            'Concession': totals.totalNegativeSum, 'Cash': totals.cashSum, 'UPI': totals.upiSum, 'Dbank': totals.DbankSum,
            'Mode Amt': totals.AgentSum, 'Total': totals.totalSum, 'Added By': '', 'Mode': ''
        });

        const keys = Object.keys(data[0]);
        const aoa = [keys, ...data.map(r => keys.map(k => r[k]))];
        const ws = XLSX.utils.aoa_to_sheet(aoa);
        ws['!cols'] = keys.map(k => ({ wch: Math.max(k.length + 2, 12) }));

        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let c = range.s.c; c <= range.e.c; c++) {
            const addr = XLSX.utils.encode_cell({ r: 0, c });
            if (ws[addr]) {
                ws[addr].s = {
                    font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 },
                    fill: { fgColor: { rgb: '1565C0' } },
                    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
                    border: { top: { style: 'thin', color: { rgb: '1565C0' } }, bottom: { style: 'thin', color: { rgb: '1565C0' } }, left: { style: 'thin', color: { rgb: '1565C0' } }, right: { style: 'thin', color: { rgb: '1565C0' } } }
                };
            }
        }

        const lastRow = range.e.r;
        for (let r = 1; r <= range.e.r; r++) {
            for (let c = range.s.c; c <= range.e.c; c++) {
                const addr = XLSX.utils.encode_cell({ r, c });
                if (!ws[addr]) ws[addr] = { v: '', t: 's' };
                const isNum = typeof ws[addr].v === 'number';
                const isTotal = r === lastRow;
                const isEven = r % 2 === 0;
                ws[addr].s = {
                    font: { sz: 10, bold: isTotal, color: { rgb: isTotal ? 'FFFFFF' : '333333' } },
                    fill: isTotal ? { fgColor: { rgb: '1565C0' } } : (isEven ? { fgColor: { rgb: 'E3F2FD' } } : { fgColor: { rgb: 'FFFFFF' } }),
                    alignment: { horizontal: isNum ? 'right' : 'left', vertical: 'center' },
                    border: { top: { style: 'thin', color: { rgb: 'DDDDDD' } }, bottom: { style: 'thin', color: { rgb: 'DDDDDD' } }, left: { style: 'thin', color: { rgb: 'DDDDDD' } }, right: { style: 'thin', color: { rgb: 'DDDDDD' } } },
                    ...(isNum ? { numFmt: '#,##0.00' } : {})
                };
            }
        }

        ws['!rows'] = [{ hpt: 22 }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Paid List');
        XLSX.writeFile(wb, `PaidList_${moment(selectedFrom).format('DDMMMYY')}_${moment(selectedTo).format('DDMMMYY')}.xlsx`);
        toast.success(`Excel exported (${exportTasks.length} records)!`, { id: loadingToast });
        } catch (error) {
            console.error('Error exporting Excel:', error);
            toast.error('Failed to export Excel', { id: loadingToast });
        } finally {
            setExporting(false);
        }
    };

    const handleExportPdf = async () => {
        if (tasks.length === 0) { toast.error('No data to export'); return; }
        setExporting(true);
        const loadingToast = toast.loading('Preparing PDF export...');
        try {
            const exportTasks = await fetchAllTasksForExport();
            if (exportTasks.length === 0) {
                toast.error('No data to export', { id: loadingToast });
                return;
            }
            const totals = calculateExportTotals(exportTasks);
        const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
        const w = doc.internal.pageSize.getWidth();

        doc.setFontSize(14); doc.setTextColor(21, 101, 192);
        doc.text('Student Pay List', w / 2, 14, { align: 'center' });

        doc.setFontSize(9); doc.setTextColor(100);
        const dateRange = `${moment(selectedFrom).format('DD MMM, YYYY')} — ${moment(selectedTo).format('DD MMM, YYYY')}`;
        doc.text(dateRange, w / 2, 20, { align: 'center' });

        doc.setFillColor(21, 101, 192); doc.rect(10, 23, w - 20, 7, 'F');
        doc.setFontSize(10); doc.setTextColor(255);
        doc.text(`PAID LIST — ${exportTasks.length} Records`, w / 2, 28, { align: 'center' });

        const pdfHeaders = ['#', 'Paid On', 'Adm No', 'Student', 'Type', 'Class', 'Div', 'Fee Type', 'Head', 'Ref', 'Conc.', 'Cash', 'UPI', 'Dbank', 'Mode', 'Total', 'Excl.Conc', 'Add By'];
        const pdfRows = exportTasks.map((task, idx) => {
            const amt = parseFloat(task.amount) || 0;
            const conc = task.ext_1 === 'Concession' ? amt : 0;
            return [
                idx + 1,
                task.alt_date ? moment(task.alt_date).format('DD MMM,YY') : moment(task.created_at).format('DD MMM,YY'),
                task.adm_no || '',
                `${task.first_name || ''} ${(task.last_name || '').substring(0, 10)}`.trim(),
                getStudentType(task),
                task.class || '',
                task.dev || '',
                task.fees_name ? task.fees_name.name : 'N/A',
                task.fees_name?.fees_type_head?.name || '-',
                task.ext_2 || '',
                conc ? conc.toFixed(2) : '',
                task.ext_1 === 'Cash' ? amt.toFixed(2) : '',
                task.ext_1 === 'UPI' ? amt.toFixed(2) : '',
                task.ext_1 === 'Dbank' ? amt.toFixed(2) : '',
                task.ext_1 === 'Agent' ? amt.toFixed(2) : '',
                amt.toFixed(2),
                (amt - conc).toFixed(2),
                task.user_name ? task.user_name.name : '',
            ];
        });

        const exclConcTotal = (totals.totalSum - totals.totalNegativeSum).toFixed(2);
        pdfRows.push(['', '', '', '', '', '', '', 'TOTAL', '', '',
            totals.totalNegativeSum.toFixed(2), totals.cashSum.toFixed(2), totals.upiSum.toFixed(2), totals.DbankSum.toFixed(2),
            totals.AgentSum.toFixed(2), totals.totalSum.toFixed(2), exclConcTotal, ''
        ]);

        autoTable(doc, {
            head: [pdfHeaders], body: pdfRows, startY: 33, theme: 'grid',
            headStyles: { fillColor: [21, 101, 192], textColor: 255, fontSize: 6.5, halign: 'center', cellPadding: 1.5 },
            bodyStyles: { fontSize: 6.5, cellPadding: 1.2 },
            alternateRowStyles: { fillColor: [227, 242, 253] },
            columnStyles: {
                0: { halign: 'center', cellWidth: 8 },
                10: { halign: 'right' }, 11: { halign: 'right' }, 12: { halign: 'right' },
                13: { halign: 'right' }, 14: { halign: 'right' }, 15: { halign: 'right', fontStyle: 'bold' },
                16: { halign: 'right', fontStyle: 'bold' },
            },
            didParseCell: (data) => {
                if (data.row.index === pdfRows.length - 1) {
                    data.cell.styles.fillColor = [21, 101, 192];
                    data.cell.styles.textColor = 255;
                    data.cell.styles.fontStyle = 'bold';
                }
            },
            margin: { left: 10, right: 10 },
        });

        // Fees Type Summary Section
        const feesTypeSummary = {};
        exportTasks.forEach((task) => {
            const ftName = task.fees_name ? task.fees_name.name : 'N/A';
            if (!feesTypeSummary[ftName]) feesTypeSummary[ftName] = { conc: 0, cash: 0, upi: 0, dbank: 0, mode: 0, total: 0 };
            const amt = parseFloat(task.amount) || 0;
            if (task.ext_1 === 'Concession') feesTypeSummary[ftName].conc += amt;
            else if (task.ext_1 === 'Cash') feesTypeSummary[ftName].cash += amt;
            else if (task.ext_1 === 'UPI') feesTypeSummary[ftName].upi += amt;
            else if (task.ext_1 === 'Dbank') feesTypeSummary[ftName].dbank += amt;
            else if (task.ext_1 === 'Agent') feesTypeSummary[ftName].mode += amt;
            feesTypeSummary[ftName].total += amt;
        });

        let summaryY = doc.lastAutoTable.finalY + 10;
        if (summaryY > 180) { doc.addPage(); summaryY = 15; }

        doc.setFontSize(10); doc.setTextColor(33, 33, 33);
        doc.text('Summary by Fee Type', 14, summaryY);

        const summaryHeaders = [['Fee Type', 'Concession', 'Cash', 'UPI', 'Dbank', 'Mode', 'Total']];
        const summaryRows = Object.entries(feesTypeSummary).map(([name, s]) => [
            name, s.conc.toFixed(2), s.cash.toFixed(2), s.upi.toFixed(2), s.dbank.toFixed(2), s.mode.toFixed(2), s.total.toFixed(2)
        ]);
        summaryRows.push(['GRAND TOTAL', totals.totalNegativeSum.toFixed(2), totals.cashSum.toFixed(2), totals.upiSum.toFixed(2), totals.DbankSum.toFixed(2), totals.AgentSum.toFixed(2), totals.totalSum.toFixed(2)]);

        autoTable(doc, {
            head: summaryHeaders, body: summaryRows, startY: summaryY + 3, theme: 'grid',
            headStyles: { fillColor: [56, 142, 60], textColor: 255, fontSize: 8, halign: 'center', cellPadding: 2 },
            bodyStyles: { fontSize: 7.5, cellPadding: 1.8 },
            columnStyles: { 1: { halign: 'right' }, 2: { halign: 'right' }, 3: { halign: 'right' }, 4: { halign: 'right' }, 5: { halign: 'right' }, 6: { halign: 'right', fontStyle: 'bold' } },
            didParseCell: (data) => {
                if (data.section === 'body' && data.row.index === summaryRows.length - 1) {
                    data.cell.styles.fillColor = [56, 142, 60];
                    data.cell.styles.textColor = 255;
                    data.cell.styles.fontStyle = 'bold';
                }
            },
            margin: { left: 10, right: 10 },
        });

        doc.save(`PaidList_${moment(selectedFrom).format('DDMMMYY')}_${moment(selectedTo).format('DDMMMYY')}.pdf`);
        toast.success(`PDF exported (${exportTasks.length} records)!`, { id: loadingToast });
        } catch (error) {
            console.error('Error exporting PDF:', error);
            toast.error('Failed to export PDF', { id: loadingToast });
        } finally {
            setExporting(false);
        }
    };

    return (
        <>
            <style>{compactTableStyles}</style>
            <Toaster />
            <div className="container-fluid mt-2">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <div>
                        <h5 className="mb-0 fw-bold">Student Pay List</h5>
                        <small style={{fontSize: '0.7rem'}}>
                            <span className="me-3"><strong style={{color: '#198754'}}>● Paid Date</strong></span>
                            <span style={{color: '#17a2b8'}}><strong>● Created Date</strong></span>
                        </small>
                    </div>
                    <div className="d-flex gap-1 flex-wrap">
                        <Link to="/fees_head_details" className="btn btn-outline-primary btn-sm px-2 py-0" style={{fontSize: '0.75rem'}}>
                            <i className="fas fa-layer-group me-1"></i>Fees Head Details
                        </Link>
                        <Link to="/fees_item" className="btn btn-outline-secondary btn-sm px-2 py-0" style={{fontSize: '0.75rem'}} onClick={handleClearFields}>
                            Clear
                        </Link>
                        <Link to="#" className="btn btn-outline-success btn-sm px-2 py-0" style={{fontSize: '0.75rem'}} onClick={handleEmailSentExport}>
                            <i className="fas fa-download me-1"></i>CSV
                        </Link>
                        <Link to="#" className="btn btn-outline-warning btn-sm px-2 py-0" style={{fontSize: '0.75rem'}} onClick={handleEmailSentExportFilter}>
                            <i className="fas fa-filter me-1"></i>Filter CSV
                        </Link>
                        <button className="btn btn-outline-success btn-sm px-2 py-0" style={{fontSize: '0.75rem'}} onClick={handleExportExcel} disabled={tasks.length === 0 || exporting}>
                            <i className="fas fa-file-excel me-1"></i>{exporting ? 'Exporting...' : 'Excel'}
                        </button>
                        <button className="btn btn-outline-danger btn-sm px-2 py-0" style={{fontSize: '0.75rem'}} onClick={handleExportPdf} disabled={tasks.length === 0 || exporting}>
                            <i className="fas fa-file-pdf me-1"></i>{exporting ? 'Exporting...' : 'PDF'}
                        </button>
                        <button className="btn btn-outline-info btn-sm px-2 py-0" style={{fontSize: '0.75rem'}} onClick={() => { setReportStep(1); setSelectedReportAdmin(null); setShowReportModal(true); }}>
                            <i className="fas fa-envelope me-1"></i>Send
                        </button>
                    </div>
                </div>

                <div className="row g-2 align-items-center">
                    <div className="col-auto">
                        <select onChange={handleMonthChange} className="form-control form-control-sm border border-warning border-2" style={{fontSize: '12px', minWidth: '90px'}} title="Select Month">
                            <option value="">Month</option>
                            <option value="01">January</option>
                            <option value="02">February</option>
                            <option value="03">March</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">August</option>
                            <option value="09">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                        </select>
                    </div>
                    <div className="col">
                        <input type="date" name="due_date_start" className="form-control form-control-sm border border-success border-2" value={selectedFrom} onChange={handleChangeDate} title="Paid Date From" />
                    </div>
                    <div className="col">
                        <input type="date" name="due_date_end" className="form-control form-control-sm border border-success border-2" value={selectedTo} onChange={handleChangeDateEnd} title="Paid Date To" />
                    </div>
                    <div className="col">
                        <Select
                            isMulti
                            options={stClass.map((option) => ({ value: option.class_name, label: option.class_name }))}
                            onChange={(selected) => setselectedClassStud(selected || [])}
                            value={selectedClassStud}
                            isClearable
                            placeholder="Class"
                            menuPlacement="auto"
                            menuPosition="absolute"
                            styles={{
                                control: (base) => ({ ...base, minHeight: '31px', fontSize: '12px' }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                multiValue: (base) => ({ ...base, backgroundColor: '#e3f2fd', borderRadius: '3px' }),
                                multiValueLabel: (base) => ({ ...base, fontSize: '11px', padding: '0 3px' }),
                                multiValueRemove: (base) => ({ ...base, ':hover': { backgroundColor: '#bbdefb', color: '#1565c0' } }),
                                placeholder: (base) => ({ ...base, fontSize: '12px' }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px' }),
                                dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                                clearIndicator: (base) => ({ ...base, padding: '2px' }),
                            }}
                        />
                    </div>
                    <div className="col">
                        <Select
                            isMulti
                            options={fees.map((option) => ({ value: option.id, label: option.name }))}
                            onChange={(selected) => setselectedDevStudType(selected || [])}
                            value={selectedDevStudType}
                            isClearable
                            placeholder="Fees Type"
                            isLoading={loading}
                            menuPlacement="auto"
                            menuPosition="absolute"
                            styles={{
                                control: (base) => ({ ...base, minHeight: '31px', fontSize: '12px' }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                multiValue: (base) => ({ ...base, backgroundColor: '#fff3e0', borderRadius: '3px' }),
                                multiValueLabel: (base) => ({ ...base, fontSize: '11px', padding: '0 3px' }),
                                multiValueRemove: (base) => ({ ...base, ':hover': { backgroundColor: '#ffe0b2', color: '#e65100' } }),
                                placeholder: (base) => ({ ...base, fontSize: '12px' }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px' }),
                                dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                                clearIndicator: (base) => ({ ...base, padding: '2px' }),
                            }}
                        />
                    </div>
                    <div className="col">
                        <select onChange={handleSelectChangeDev} className="form-control form-control-sm">
                            <option value="">Div</option>
                            {stDev.map((options, index) => (
                                <option key={index} value={options.name}>{options.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col">
                        <Select
                            isMulti
                            options={stYear.map((option) => ({ value: option.name, label: option.name }))}
                            onChange={handleSelectChangeYear}
                            value={selectedDevYear}
                            isClearable
                            placeholder="Year"
                            menuPlacement="auto"
                            menuPosition="absolute"
                            styles={{
                                control: (base) => ({ ...base, minHeight: '31px', fontSize: '12px' }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                multiValue: (base) => ({ ...base, backgroundColor: '#e8f5e9', borderRadius: '3px' }),
                                multiValueLabel: (base) => ({ ...base, fontSize: '11px', padding: '0 3px' }),
                                multiValueRemove: (base) => ({ ...base, ':hover': { backgroundColor: '#c8e6c9', color: '#2e7d32' } }),
                                placeholder: (base) => ({ ...base, fontSize: '12px' }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px' }),
                                dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                                clearIndicator: (base) => ({ ...base, padding: '2px' }),
                            }}
                        />
                    </div>
                    <div className="col">
                        <Select
                            options={[
                                { value: "", label: "Mode" },
                                ...stAgent.map((option) => ({ value: option.id, label: option.name }))
                            ]}
                            onChange={(selectedOption) => setselectedDevStudAgentType(selectedOption ? selectedOption.value : "")}
                            value={stAgent.find(option => option.id === selectedDevStudAgentType)
                                ? { value: selectedDevStudAgentType, label: stAgent.find(option => option.id === selectedDevStudAgentType).name }
                                : { value: "", label: "Mode" }}
                            isClearable
                            placeholder="Mode"
                            menuPlacement="auto"
                            menuPosition="absolute"
                            styles={{
                                control: (base) => ({ ...base, minHeight: '31px', fontSize: '12px' }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                placeholder: (base) => ({ ...base, fontSize: '12px' }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px' }),
                                dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                                clearIndicator: (base) => ({ ...base, padding: '2px' }),
                            }}
                        />
                    </div>
                </div>

                <div className="row g-2 align-items-center mt-1">
                    <div className="col-auto" style={{minWidth: '170px'}}>
                        <Select
                            isMulti
                            options={feesTypeHeads.map((h) => ({ value: h.id, label: h.name }))}
                            onChange={(selected) => setSelectedHead(selected || [])}
                            value={selectedHead}
                            isClearable
                            placeholder="Fees Head"
                            menuPlacement="auto"
                            menuPosition="absolute"
                            styles={{
                                control: (base) => ({ ...base, minHeight: '31px', fontSize: '12px' }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                multiValue: (base) => ({ ...base, backgroundColor: '#e8f5e9', borderRadius: '3px' }),
                                multiValueLabel: (base) => ({ ...base, fontSize: '11px', padding: '0 3px' }),
                                multiValueRemove: (base) => ({ ...base, ':hover': { backgroundColor: '#c8e6c9', color: '#2e7d32' } }),
                                placeholder: (base) => ({ ...base, fontSize: '12px' }),
                                valueContainer: (base) => ({ ...base, padding: '0 6px' }),
                                dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                                clearIndicator: (base) => ({ ...base, padding: '2px' }),
                            }}
                        />
                    </div>
                    <div className="col-auto">
                        <select onChange={handleSelectChangeAdmin} className="form-control form-control-sm" style={{fontSize: '12px'}}>
                            <option value="">Added By</option>
                            {stAdmin.map((options, index) => (
                                <option key={index} value={options.id}>{options.name} {options.last_name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-auto">
                        <input type="date" className="form-control form-control-sm border border-info" value={createdFrom} onChange={(e) => setCreatedFrom(e.target.value)} title="Created From" style={{fontSize: '12px'}} />
                    </div>
                    <div className="col-auto">
                        <input type="date" className="form-control form-control-sm border border-info" value={createdTo} onChange={(e) => setCreatedTo(e.target.value)} title="Created To" style={{fontSize: '12px'}} />
                    </div>
                    <div className="col-auto">
                        <button className="btn btn-primary btn-sm px-3" onClick={handleFilter}>
                            <i className="fas fa-search me-1"></i>Search
                        </button>
                    </div>
                </div>
                <hr />
                <div className="row">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped table-hover mt-2 compact-paid-table">
                            <thead className="table-primary">

                                <tr>
                                    <th className="text-danger" style={{minWidth: '40px'}}>No</th>
                                    <th style={{minWidth: '85px'}}>Paid On</th>
                                    <th style={{minWidth: '85px'}}>Created</th>
                                    <th style={{minWidth: '75px'}}>Adm No</th>
                                    <th style={{minWidth: '120px'}}>Student Name</th>
                                    <th style={{minWidth: '60px'}}>Class</th>
                                    <th style={{minWidth: '50px'}}>Div</th>
                                    <th style={{minWidth: '100px'}}>Fee Type</th>
                                    <th style={{minWidth: '80px'}}>Head</th>
                                    <th style={{minWidth: '60px'}}>Invoice</th>
                                    <th style={{minWidth: '60px'}}>CInvoice</th>
                                    <th style={{minWidth: '75px'}}>Concession</th>
                                    <th style={{minWidth: '65px'}}>Cash</th>
                                    <th style={{minWidth: '65px'}}>UPI</th>
                                    <th style={{minWidth: '65px'}}>Dbank</th>
                                    <th style={{minWidth: '65px'}}>Mode</th>
                                    <th style={{minWidth: '65px'}}>Total</th>
                                    <th style={{minWidth: '85px'}}>Add By</th>
                                    <th style={{minWidth: '85px'}}>Mode</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>  (<b>{totalNegativeSum.toFixed(2)}</b>)</th>
                                    <th> (<b>{cashSum.toFixed(2)}</b>)</th>
                                    <th> (<b>{upiSum.toFixed(2)}</b>)</th>
                                    <th> (<b>{DbankSum.toFixed(2)}</b>)</th>
                                    <th> (<b>{AgentSum.toFixed(2)}</b>)</th>
                                    <th> (<b>{totalSum.toFixed(2)}</b>)</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((task, index) => (
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>
                                            {task.alt_date ? moment(task.alt_date).format("DD MMM,YY") : moment(task.created_at).format("DD MMM,YY")}
                                        </td>
                                        <td>{task.created_at ? moment(task.created_at).format("DD MMM, YY HH:mm") : '—'}</td>
                                        <td>{task.adm_no}</td>
                                        <td>{task.first_name} {formatLastName(task.last_name)}</td>
                                        <td>{task.class}</td>
                                        <td>{task.dev}</td>
                                        <td>{task.fees_name ? task.fees_name.name : 'N/A'}</td>
                                        <td>{task.fees_name?.fees_type_head?.name || '-'}</td>
                                        <td>
                                            {task.invoice ? (
                                                <Link to={`/print/${task.invoice.paid_id}`} target='_blank'>
                                                    {task.invoice.invoice_id}
                                                </Link>
                                            ) : (
                                                ''
                                            )}
                                        </td>

                                        <td>
                                            {task.cinvoice ? (
                                                <Link to={`/print_all/${task.cinvoice.club_id}`}>
                                                    {task.cinvoice.invoice_id}
                                                </Link>
                                            ) : (
                                                ''
                                            )}
                                        </td>

                                        <td> {(
                                            <b><span style={{ color: 'red' }}>{task.ext_1 === "Concession" && task.amount}</span></b>
                                        )}</td>
                                        <td>{task.ext_1 === "Cash" && task.amount}</td>
                                        <td>{task.ext_1 === "UPI" && task.amount}</td>
                                        <td>{task.ext_1 === "Dbank" && task.amount}</td>
                                        <td>{task.ext_1 === "Agent" && task.amount}</td>
                                        <td><b>{task.amount}</b></td>
                                        <td>{task.user_name ? task.user_name.name.toUpperCase() : 'N/A'}</td>
                                        <td>{task.agent_data ? task.agent_data.name : 'N/A'}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    )}

                </div>

                <div className="pagination-controls">
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={Math.ceil(totalTasks / tasksPerPage)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item'}
                        nextLinkClassName={'page-link'}
                        breakClassName={'page-item'}
                        breakLinkClassName={'page-link'}
                        activeClassName={'active'}
                    />
                </div>


            </div >

            {showReportModal && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className={`modal-dialog modal-dialog-centered ${reportStep === 1 ? 'modal-xl' : ''}`}>
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)', color: '#fff', padding: '12px 20px' }}>
                                <h6 className="modal-title mb-0">
                                    {reportStep === 1 ? (
                                        <><i className="fas fa-eye me-2"></i>Report Preview — {tasks.length} records</>
                                    ) : (
                                        <><i className="fas fa-paper-plane me-2"></i>Select Recipient</>
                                    )}
                                </h6>
                                <button type="button" className="btn-close btn-close-white" onClick={() => { setShowReportModal(false); setSelectedReportAdmin(null); }}></button>
                            </div>
                            <div className="modal-body" style={{ padding: reportStep === 1 ? '0' : '16px' }}>
                                {reportStep === 1 ? (
                                    <>
                                        <div className="px-3 py-2 d-flex flex-wrap gap-2 align-items-center" style={{ background: '#f8f9fa', borderBottom: '1px solid #dee2e6', fontSize: '0.78rem' }}>
                                            {selectedFrom && <span className="badge bg-primary">From: {moment(selectedFrom).format('DD MMM, YY')}</span>}
                                            {selectedTo && <span className="badge bg-primary">To: {moment(selectedTo).format('DD MMM, YY')}</span>}
                                            {createdFrom && <span className="badge bg-info text-dark">Created From: {moment(createdFrom).format('DD MMM, YY')}</span>}
                                            {createdTo && <span className="badge bg-info text-dark">Created To: {moment(createdTo).format('DD MMM, YY')}</span>}
                                            {selectedClassStud.length > 0 && <span className="badge bg-secondary">Class: {selectedClassStud.map(o => o.label).join(', ')}</span>}
                                            {selectedDevStud && <span className="badge bg-secondary">Div: {selectedDevStud}</span>}
                                            {selectedDevStudType.length > 0 && <span className="badge bg-secondary">Fee Type: {selectedDevStudType.map(o => o.label).join(', ')}</span>}
                                            {selectedHead.length > 0 && <span className="badge bg-success">Head: {selectedHead.map(o => o.label).join(', ')}</span>}
                                        </div>
                                        <div style={{ maxHeight: '55vh', overflowY: 'auto', overflowX: 'auto' }}>
                                            <table className="table table-sm table-bordered mb-0" style={{ fontSize: '0.72rem' }}>
                                                <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                    <tr style={{ background: '#2c3e50', color: '#fff' }}>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>No</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Paid On</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Adm No</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Student Name</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Class</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Div</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Fee Type</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Head</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap', textAlign: 'right' }}>Concession</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap', textAlign: 'right' }}>Cash</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap', textAlign: 'right' }}>UPI</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap', textAlign: 'right' }}>Dbank</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap', textAlign: 'right' }}>Agent</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap', textAlign: 'right' }}>Total</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Add By</th>
                                                        <th style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>Reff</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tasks.map((task, index) => (
                                                        <tr key={index} style={{ background: index % 2 === 0 ? '#fff' : '#f7f9fc' }}>
                                                            <td style={{ padding: '5px 8px' }}>{index + 1}</td>
                                                            <td style={{ padding: '5px 8px', whiteSpace: 'nowrap' }}>
                                                                {task.alt_date ? moment(task.alt_date).format('DD MMM,YY') : moment(task.created_at).format('DD MMM,YY')}
                                                            </td>
                                                            <td style={{ padding: '5px 8px' }}>{task.adm_no}</td>
                                                            <td style={{ padding: '5px 8px', whiteSpace: 'nowrap' }}>{task.first_name} {task.last_name}</td>
                                                            <td style={{ padding: '5px 8px', textAlign: 'center' }}>{task.class}</td>
                                                            <td style={{ padding: '5px 8px', textAlign: 'center' }}>{task.dev}</td>
                                                            <td style={{ padding: '5px 8px' }}>{task.fees_name ? task.fees_name.name : 'N/A'}</td>
                                                            <td style={{ padding: '5px 8px' }}>{task.fees_name?.fees_type_head?.name || '-'}</td>
                                                            <td style={{ padding: '5px 8px', textAlign: 'right', color: '#dc3545', fontWeight: task.ext_1 === 'Concession' ? 600 : 400 }}>
                                                                {task.ext_1 === 'Concession' ? parseFloat(task.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 }) : ''}
                                                            </td>
                                                            <td style={{ padding: '5px 8px', textAlign: 'right' }}>
                                                                {task.ext_1 === 'Cash' ? parseFloat(task.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 }) : ''}
                                                            </td>
                                                            <td style={{ padding: '5px 8px', textAlign: 'right' }}>
                                                                {task.ext_1 === 'UPI' ? parseFloat(task.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 }) : ''}
                                                            </td>
                                                            <td style={{ padding: '5px 8px', textAlign: 'right' }}>
                                                                {task.ext_1 === 'Dbank' ? parseFloat(task.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 }) : ''}
                                                            </td>
                                                            <td style={{ padding: '5px 8px', textAlign: 'right' }}>
                                                                {task.ext_1 === 'Agent' ? parseFloat(task.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 }) : ''}
                                                            </td>
                                                            <td style={{ padding: '5px 8px', textAlign: 'right', fontWeight: 700 }}>
                                                                {parseFloat(task.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                            </td>
                                                            <td style={{ padding: '5px 8px', whiteSpace: 'nowrap' }}>{task.user_name ? task.user_name.name.toUpperCase() : 'N/A'}</td>
                                                            <td style={{ padding: '5px 8px' }}>{task.ext_2 || 'N/A'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr style={{ background: '#1a237e', color: '#fff', fontWeight: 700 }}>
                                                        <td colSpan={8} style={{ padding: '6px 8px', textAlign: 'right' }}>TOTAL</td>
                                                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{totalNegativeSum.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{cashSum.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{upiSum.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{DbankSum.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{AgentSum.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{totalSum.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                        <td colSpan={2} style={{ padding: '6px 8px' }}></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {superAdmins.length === 0 ? (
                                            <p className="text-muted">No super admins found.</p>
                                        ) : (
                                            <div className="list-group">
                                                {superAdmins.map((admin) => (
                                                    <label
                                                        key={admin.id}
                                                        className={`list-group-item list-group-item-action d-flex align-items-center gap-3 ${selectedReportAdmin?.id === admin.id ? 'active' : ''}`}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="reportAdmin"
                                                            className="form-check-input mt-0"
                                                            checked={selectedReportAdmin?.id === admin.id}
                                                            onChange={() => setSelectedReportAdmin(admin)}
                                                        />
                                                        <div>
                                                            <div className="fw-bold">{admin.name} {admin.last_name}</div>
                                                            <small className={selectedReportAdmin?.id === admin.id ? 'text-light' : 'text-muted'}>{admin.email}</small>
                                                        </div>
                                                    </label>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                            <div className="modal-footer" style={{ padding: '10px 20px' }}>
                                {reportStep === 1 ? (
                                    <>
                                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setShowReportModal(false); setSelectedReportAdmin(null); }}>Cancel</button>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={() => setReportStep(2)}
                                            disabled={tasks.length === 0}
                                        >
                                            <i className="fas fa-arrow-right me-1"></i>Proceed to Send
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setReportStep(1)}>
                                            <i className="fas fa-arrow-left me-1"></i>Back to Preview
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={handleSendReport}
                                            disabled={!selectedReportAdmin || sendingReport}
                                        >
                                            {sendingReport ? (
                                                <><span className="spinner-border spinner-border-sm me-1"></span>Sending...</>
                                            ) : (
                                                <><i className="fas fa-paper-plane me-1"></i>Send</>
                                            )}
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
